import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionIndex } from '@/pages/billing/SubscriptionIndex';

export const Route = createFileRoute('/_authenticated/_app/settings/billing/')({
	component: SubscriptionIndex,
});
